import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BaseGetAll, BaseResponse } from '../shared/commons/generic.responses';
import { GenericCatalogReq } from './models/generic-catalog';
import { catalogQueries, endpoints } from '../shared/apis/endpoints';
import { Accesorial } from './models/accesorial';
import { BoxSize } from './models/boxsizes';
import { DriverCatalogReq } from './pages/drivers/drivers.component';
import { Driver, DriverLinkableAppUser } from './models/drivers';
import { AdminApiResponse } from '../admin/models/api-response';
import { Rate } from './models/rates';
import { CityRate, CityRateMilesRequest } from './models/city';
import { CityRateReq } from './pages/city-rate/city-rate.component';
import { Lease } from './models/leaseTo';

@Injectable({
    providedIn: 'root'
})
export class CatalogService {

    constructor(private _http: HttpClient) { }


    GenericGetCatalog<T extends object>(req: GenericCatalogReq, endpoint: string): Observable<BaseResponse<T[]>> {
        const parameters = JSON.parse(JSON.stringify(req));
        return this._http.get<BaseResponse<T[]>>(endpoint, { params: parameters });
    }

    PatchCatalog = (req: any, endpoint: string): Observable<BaseGetAll<number>> => {
        return this._http.patch<BaseGetAll<number>>(endpoint, req)
    };

    DeleteCatalog = (id: any, endpoint: string): Observable<any> => this._http.delete<any>(`${endpoint}/${id}`);


    GetAccesorials(): Observable<BaseGetAll<Accesorial[]>> {
        return this._http.get<BaseGetAll<Accesorial[]>>(endpoints.ACCESORIAL_BELONGING);
    }

    GetBoxSizes(): Observable<BaseGetAll<BoxSize[]>> {
        return this._http.get<BaseGetAll<BoxSize[]>>(`${endpoints.GENERIC_GET_ALL}?q=${catalogQueries.BOXSIZE_QUERY}`);
    }

    GetLessees(): Observable<BaseGetAll<Lease[]>> {
        return this._http.get<BaseGetAll<Lease[]>>(`${endpoints.GENERIC_GET_ALL}?q=${catalogQueries.LESSEE_QUERY}`);
    }

    GetAllDrivers(req: DriverCatalogReq): Observable<BaseGetAll<Driver[]>> {

        const parameters = JSON.parse(JSON.stringify(req));

        return this._http.get<BaseGetAll<Driver[]>>(endpoints.GET_ALL_DRIVERS, { params: parameters }).pipe(
            map((res) => {
                res.body.forEach(function (x: Driver) {
                    x.insuranceExpDate = x.insuranceExpDate?.split('T')[0];
                    x.DriverLicenseExpDate = x.DriverLicenseExpDate?.split('T')[0];
                    x.MedicalCardExpDate = x.MedicalCardExpDate?.split('T')[0];
                    x.VehicleRegistrationExpDate = x.VehicleRegistrationExpDate?.split('T')[0];
                    x.VehicleInspection90DayExpDate = x.VehicleInspection90DayExpDate?.split('T')[0];
                    const legacy = x as Driver & {
                        userId?: string;
                        driverId?: number;
                        quickBooksAccountCode?: string;
                    };
                    x.UserId = x.UserId ?? legacy.userId ?? null;
                    delete (x as { userId?: string }).userId;
                    x.QuickBooksAccountCode =
                        x.QuickBooksAccountCode ?? legacy.quickBooksAccountCode ?? null;
                    if ((x.DriverID == null || Number.isNaN(x.DriverID as any)) && legacy.driverId != null) {
                        x.DriverID = legacy.driverId;
                    }
                });

                return res;
            })
        );
    }

    GetAllRates(): Observable<BaseGetAll<Rate[]>> {
        return this._http.get<BaseGetAll<Rate[]>>(endpoints.GET_RATES);
    }

    GetAllCityRates(req: CityRateReq) : Observable<BaseGetAll<CityRate[]>> {
        const parameters = JSON.parse(JSON.stringify(req));
        return this._http.get<BaseGetAll<CityRate[]>>(endpoints.GET_CITY_RATES, { params: parameters } )
    }

    PatchCityRateMiles(req: CityRateMilesRequest): Observable<BaseGetAll<number>> {
        return this._http.patch<BaseGetAll<number>>(endpoints.PATCH_CITY_RATE_MILES, req);
    }

    /**
     * Usuarios de aplicación que pueden asignarse a este driver (no usados por otro driver,
     * más el usuario actualmente vinculado a driverId si existe).
     */
    GetAppUsersAvailableForDriver(driverId: number): Observable<AdminApiResponse<DriverLinkableAppUser[]>> {
        return this._http.get<AdminApiResponse<DriverLinkableAppUser[]>>(
            endpoints.DRIVER_AVAILABLE_APP_USERS,
            { params: { driverId: String(driverId) } }
        );
    }

}
